import { useCallback, useState } from "react";
import DialogCriacaoEditBancos from "./DialogCriacaoEditBancos";
import { TBancos } from "../../../../../types/api/financeiro/bancos";
import SessaoConfiguracao, { ConfiguracaoColunas } from "../../../../../components/BasicComponents/DisplayDados/SessaoConfiguracao";


export default function Bancos() {

    const [openModal, setOpenModal] = useState<TOpenModal>(null)
    //funções manipuladoras
    const handleModalAction = useCallback((action: "open" | "close", id?: true | number, value?: TBancos | null) => {
        if (action === "close") setOpenModal(null)
        if (action === "open" && id && value) setOpenModal({ open: id, defaultValue: value })
        if (action === "open" && id && !value) setOpenModal({ open: id, defaultValue: null })
    }, [])
    //
    return (
        <>
            <SessaoConfiguracao<TBancos>
                titulo="Bancos"
                endpoints={{
                    listar: "financeiro/configuracoes/pesquisar-bancos",
                    deletar: "financeiro/configuracoes/excluir-banco",
                }}
                colunas={colunas}
                queryKey="pesquisar-bancos"
                onEditar={(banco) => {
                    handleModalAction("open", banco.id, banco)
                }}
                onAdicionar={() => {
                    handleModalAction("open", true, null)
                }}
                mensagemSucessoDeletar="Banco deletado com sucesso!"
                mensagemErroDeletar="Erro ao deletar banco!"
                mensagemSemDados="Nenhum banco encontrado."
            />

            {
                Boolean(openModal?.open) &&
                <DialogCriacaoEditBancos
                    defaultValue={openModal?.defaultValue ? openModal : null}
                    open={Boolean(openModal?.open)}
                    handleClose={() => handleModalAction("close")}
                />
            }

        </>
    )
}

export type TOpenModal = {
    open: number | boolean | null;
    defaultValue: TBancos | null;
} | null

const colunas: ConfiguracaoColunas<TBancos>[] = [
    {
        campo: "nome",
        titulo: "Nome",
    },
    {
        campo: "codigo",
        titulo: "Código",
    }
];
